// utils/getApiForRole.js

import { Api } from "../../../api";
import { CompanyApi } from "../../../api/companyApi";
import { isSuperAdmin, isCopanySuperOrSubAdmin } from "../../../utils/helper";

export const ApiForRole = () => {
  if (isSuperAdmin()) return Api;
  if (isCopanySuperOrSubAdmin()) return CompanyApi;
  throw new Error("Invalid user type");
};
